<div class="app-ActionBar-content">
  <ng-content select="appActionBarLeftContent"></ng-content>
  <ng-content select="appActionBarCenterContent"></ng-content>
  <ng-content select="appActonBarRightContent"></ng-content>
</div>
